import { FormNameEnum, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult } from '../../types'
import { useOrgFormStatus } from '../useOrgFormFields'

const FORM_NAME = FormNameEnum.EnrollmentSuccess
const FORM_VERSION = 1

export const useEnrollmentSuccessStatus = (
  org: OrganizationDetailFragment
): Pick<HealthcheckStatusResult, 'status' | 'primary' | 'secondary'> => {
  const formStatus = useOrgFormStatus(org.id, FORM_NAME, FORM_VERSION)
  const primary = 'Enrollment success'

  if (formStatus !== 'complete') {
    return {
      status: 'incomplete',
      primary,
      secondary: 'Let us know how we can support your employees',
    }
  }

  return {
    status: 'complete',
    primary,
    secondary: 'We will use your responses to support your employees better',
  }
}
